import { DrugSource } from "@/models/Drug/DrugProduct";

export interface AutoProcessProduct {
    id: number;
    programId: number;
    packageId: number;
    drugSource: DrugSource;
    acceptedNDCs: string[];
    preferredNDC: string | null;
    defaultDirections: string | null;
    defaultCashOut: number | null;
    daysSupplyFactor: number;
    autoship: boolean;
    defaultDelivery: number | null;
    onHold: boolean;
    onHoldSubStatusId: number | null;
    webhookURL: string | null;
    passthroughSig: boolean;
    selectBasedOnInventory: boolean;
    isConsignment: boolean;
    autoBillInsurance: boolean;
    createPartialPaymentOrder: boolean;

    // Joined from DrugView
    drugName: string | null;
    ndc11: string | null;
    packageSize: number | null;
}

export function createDefaultAutoProcessProduct(programId: number): AutoProcessProduct {
    return {
        id: 0,
        programId,
        packageId: 0,
        drugSource: DrugSource.GsddFederal,
        acceptedNDCs: [],
        preferredNDC: null,
        defaultDirections: null,
        defaultCashOut: null,
        daysSupplyFactor: 1.0,
        autoship: false,
        defaultDelivery: null,
        onHold: false,
        onHoldSubStatusId: null,
        webhookURL: null,
        passthroughSig: true,
        selectBasedOnInventory: false,
        isConsignment: false,
        autoBillInsurance: false,
        createPartialPaymentOrder: false,
        drugName: null,
        ndc11: null,
        packageSize: null,
    };
}

export interface AutoProcessProductPage {
    items: AutoProcessProduct[];
    totalRows: number;
}

export interface AutoProcessBulkUpdateRequest {
    programId: number;
    ids: number[];
    autoship?: boolean | null;
    onHold?: boolean | null;
    onHoldSubStatusId?: number | null;
    setOnHoldSubStatusId: boolean;
    passthroughSig?: boolean | null;
    selectBasedOnInventory?: boolean | null;
    isConsignment?: boolean | null;
    autoBillInsurance?: boolean | null;
    createPartialPaymentOrder?: boolean | null;
    defaultDelivery?: number | null;
    setDefaultDelivery: boolean;
    defaultCashOut?: number | null;
    setDefaultCashOut: boolean;
    daysSupplyFactor?: number | null;
    webhookURL?: string | null;
    setWebhookURL: boolean;
    defaultDirections?: string | null;
    setDefaultDirections: boolean;
}

export interface AutoProcessDefaults {
    daysSupplyFactor: number;
    autoship: boolean;
    onHold: boolean;
    onHoldSubStatusId: number | null;
    passthroughSig: boolean;
    selectBasedOnInventory: boolean;
    isConsignment: boolean;
    autoBillInsurance: boolean;
    createPartialPaymentOrder: boolean;
    defaultDelivery: number | null;
    defaultCashOut: number | null;
    webhookURL: string | null;
    defaultDirections: string | null;
}

export function createDefaultAutoProcessDefaults(): AutoProcessDefaults {
    return {
        daysSupplyFactor: 1.0,
        autoship: false,
        onHold: false,
        onHoldSubStatusId: null,
        passthroughSig: true,
        selectBasedOnInventory: false,
        isConsignment: false,
        autoBillInsurance: false,
        createPartialPaymentOrder: false,
        defaultDelivery: null,
        defaultCashOut: null,
        webhookURL: null,
        defaultDirections: null,
    };
}
